import { ApiDTO_NTSPform, ApiDTO_NTSPUI_ElementList, NTSPElement } from './Ntsp_Slice'
import { TabType } from './NTSP_StatPortal'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { IANAToTzCode } from '../../Utils'

// Add type declarations for the global objects
declare global {
    interface Window {
        healthlevelGenericObjectViewer: {
            openObjectViewDialog: (context: any, config: any, mode: string, ocvType: any) => void
            OCVTYPE: {
                generic: string | number
                [key: string]: any
            }
        }
        foundationsFindAnObject: any
    }
}

// Helper function to open OCV dialogs
const openOCVDialog = (procId: number, key: string | number, name: string, title: string) => {
    if (!window.healthlevelGenericObjectViewer?.openObjectViewDialog) {
        console.error('healthlevelGenericObjectViewer not available')
        return
    }

    const objectContext = {
        Id: procId,
        Name: name,
        Description: name,
        StoredProcParams: `{"key": "${key}"}`,
        Links: {
            GET: [{
                Url: `API/v3/Object/${procId}`,
                Template: null,
                Rel: 'Object',
                ResponseHints: null,
            }],
            POST: [{
                Url: `API/v3/Object/${procId}`,
                Template: `{"key": "${key}"}`,
                Rel: 'Object',
                ResponseHints: null,
            }],
        },
        Warning: 'All OK',
        MessageResults: [],
        title,
    }

    window.healthlevelGenericObjectViewer.openObjectViewDialog(
        document.createElement('span'),
        objectContext,
        'popup',
        window.healthlevelGenericObjectViewer.OCVTYPE.generic
    )
}

export const PatientDetailsHeader = (props: {
    form: ApiDTO_NTSPform
    NTSPElements?: ApiDTO_NTSPUI_ElementList
}) => {
    const { form,  NTSPElements } = { ...props }
    //const [getOCVPatientDetials] = useGetOCVMutation()
    const VaFacility = NTSPElements?.Facilities?.find(
        (c) => c._key === form.fk_Facility
    )?.FacilityName
    const PatientFetcherProcId = NTSPElements?.PatientFetcherProcId

    const handlePatientSSNClick = (PatientId: number) => {
        if (!PatientFetcherProcId) {
            console.error('PatientFetcherProcId not available')
            return
        }
        
        try {
            openOCVDialog(
                PatientFetcherProcId,
                PatientId,
                'NTSPPatientObjectFetcher',
                `Patient Details - ${PatientId}`
            )
        } catch (error) {
            console.error('Error opening patient details:', error)
        }
    }

    // Get the patient identifier with SSN taking precedence
    const getPatientIdentifier = () => {
        if (form.PatientSSN) {
            return { value: form.PatientSSN, label: 'Patient SSN' }
        } else if (form.FinCenter) {
            return { value: form.FinCenter, label: 'Patient FIN' }
        }
        return { value: null, label: 'Patient Id' }
    }

    const patientIdentifier = getPatientIdentifier()

    return (
        <div className="form-header w-100 py-3 patient-header">
            <span>
                <h6 className="mb-0">
                    <span className="deemphasize-header">Case ID :</span> {form.CaseId || 'Unknown'}
                </h6>
            </span>
            <span>
                <h6 className="mb-0">
                    <span className="deemphasize-header ml-3">
                        {!form.PatientSSN && !!form.FinCenter ? 'Patient FIN : ' : 'Patient SSN : '}
                    </span>
                    {patientIdentifier.value ? (
                        <a
                            href="#"
                            className="ntsp-ocv-button"
                            onClick={(e) => {
                                e.preventDefault()
                                handlePatientSSNClick(Number(patientIdentifier.value))
                            }}
                        >
                            {patientIdentifier.value}
                        </a>
                    ) : (
                        'Unknown'
                    )}
                </h6>
            </span>
            <span>
                <h6 className="mb-0">
                    <span className="deemphasize-header ml-3">Patient :</span>{' '}
                    {`${form.PatientFirstName || 'Unknown'} ${form.PatientLastName || 'Unknown'}, `}
                    {typeof form.PatientAge === 'number' && form.PatientAge !== 0
                        ? `${form.PatientAge} years, `
                        : 'Unknown age, '}
                    {form.PatientDOB ? moment(form.PatientDOB).format('MM/DD/YYYY') : 'Unknown DOB'}{' '}
                    {form.fk_PatientSex === 1
                        ? 'Male'
                        : form.fk_PatientSex === 2
                          ? 'Female'
                          : 'Unknown Sex'}
                    , {VaFacility || 'Unknown Facility'}
                </h6>
            </span>
            <span>
                <h6 className="mb-0">
                    <span className="deemphasize-header ml-3">Initial Consult Date/Time :</span>{' '}
                    {moment(form.ts_Consult)?.format('MM/DD/YYYY HH:mm') || 'Unknown'}
                </h6>
            </span>
        </div>
    )
}
